import React, { useState } from 'react';
import { connect } from 'shalala';

import { Http } from '../../../../support';
import { useStore } from '../../../../store';
import { Button, Col, Modal, Row } from 'react-bootstrap';

const UsuariosBulkDestroyModal = (props) => {
  const { show, onClose, selectedRows } = props;

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState({});

  const submit = async () => {
    setBusy(true);
    setError(null);
    setResult({});

    try {
      const params = {
        usuario_ids: selectedRows.map((usuario) => usuario?.id),
        comentario: 'Eliminado por owner.',
      };
      const response = await Http.delete(`api/usuarios`, { params });
      setResult(response.data);
    } catch (err) {
      setError(err.data || err);
    } finally {
      setBusy(false);
    }
  };

  const handleOnClose = () => {
    props.listAction.paginate();
    onClose();
  };

  const notice = (
    <>
      <Row className="mt-4">
        <Col>
          <p>Todos los elementos relacionados con la cuenta seran eliminados y no podran recuperarse.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <strong>¿Estas seguro?</strong>
          </p>
        </Col>
      </Row>
    </>
  );

  const accountList = (selectedRows || []).map((usuario: any, key: any) => (
    <Row key={key}>
      <Col>
        <strong className="mr-2">{usuario.nombre}</strong>
        &mdash; {usuario.email}
      </Col>
    </Row>
  ));

  const errorList = (error?.errors || []).map((error, key) => (
    <Row key={key}>
      <Col>
        <span>{error.message}</span>
      </Col>
    </Row>
  ));

  const messageList = (result?.messages || []).map((message, key) => (
    <Row key={key}>
      <Col>
        <span className="text-danger">{message}</span>
      </Col>
    </Row>
  ));

  const hasResult = Object.keys(result).length > 0;
  const messagesCount = (result?.messages || []).length;
  const deletedCount = (result?.usuario_ids || []).length;

  return (
    <Modal
      show={show}
      centered={true}
      keyboard={false}
      backdrop="static"
      onHide={handleOnClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Se eliminaran los usuarios</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!hasResult && (
          <>
            {accountList}

            {notice}

            {error && (
              <div className="bg-danger rounded-lg text-white small p-3">
                <p>
                  <strong>No fue posible eliminar las cuentas</strong>
                </p>
                {errorList}
              </div>
            )}
          </>
        )}

        {messagesCount > 0 && (
          <>
            <p className="text-primary">
              <strong>Resultado</strong>
            </p>
            {messageList}
          </>
        )}

        {deletedCount > 0 && (
          <p className="text-primary mt-4">
            <span>Eliminados: </span>
            <strong>{deletedCount}</strong>
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        {!hasResult && (
          <Button
            type="button"
            disabled={busy}
            variant="primary"
            onClick={() => submit()}
          >
            Si, estoy seguro
          </Button>
        )}

        <Button
          type="button"
          disabled={busy}
          variant="secondary"
          onClick={() => handleOnClose()}
        >
          {!hasResult ? 'No, cancelar' : 'Salir'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapState = (state) => {
  return {list: state.app.usuarios.list};
};

const mapActions = (actions) => {
  return {listAction: actions.app.usuarios.list};
};

export default connect(useStore, mapState, mapActions)(UsuariosBulkDestroyModal);
